<template>
  <i-container class="_align-self:stretch _padding:0" am-table-view fluid>
    <div
      class="tabs -sm -stretch"
      :am-db-tabs="$store.state.partCategories.selectedCategory"
      v-if="subCategories($route.params).table"
    >
      <div class="tabs-header">
        <div
          v-for="sub in subCategories($route.params).table.subCategories"
          :key="sub.code"
          :class="`tab-title ${$route.params.subtable.includes(sub.id + '-' + sub.code) ? '-active' : null}`"
          @click="changeActiveTab(sub)"
        >
          {{ sub.name }}
        </div>
      </div>
    </div>
    <i-card color="teal" size="sm" am-table-pane>
      <div class="_display:flex _justify-content:space-between _align-items:center _margin-left:1 _margin-right:1">
        <filter-item
          @update="updateFilter"
        />
        <div style="flex:1;display:flex;justify-content:right;margin-right:25px">
          <IToggle @update:modelValue="setShowAllTabs" :modelValue="showAllTabs" />
          All Tabs
        </div>
        <div>
          <i-button
            size="sm"
            color="secondary"
            @click="$router.push({
              name: 'DataBaseView',
              params: {
                db: $route.params.db,
                table: $route.params.table,
                subtable: $route.params.subtable
              }
            })"
            am-add-button
          >
            DataBase
          </i-button>
          <i-button
            size="sm"
            color="success"
            class="_margin-left:1/4"
            @click="$router.push({
              name: 'InstructionForm',
              params: {
                id: 'new'
              },
              query: {
                ...$route.params,
                ...$route.query
              }
            })"
          >
            Create
            <i-icon name="ink-check" class="_margin-left:1/2" />
          </i-button>
        </div>
      </div>
    </i-card>
    <div v-if="instructions.instructionsData[$route.params.subtable]" am-instruction-table>
      <i-card>
        <i-input
          v-model="searchValue"
          clearable
          placeholder="Search.."
        />
      </i-card>
      <i-table border>
        <thead>
          <tr>
            <th>#</th>
            <th>id</th>
            <th>step name</th>
            <th>step</th>
            <th>conditions</th>
            <th>image</th>
            <th>content</th>
            <th>isActive</th>
            <th>actions</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(instruction, index) in instructions.instructionsData[$route.params.subtable].data"
            :key="instruction.id"
          >
            <th><div am-index>
              {{ (index + 1) + 50 * (page - 1) }}
            </div></th>
            <th><div am-id>{{instruction.id}}</div></th>
            <td><div am-name>{{instruction.step_name}}</div></td>
            <td><div am-id>{{instruction.step}}</div></td>
            <td>
              <div am-cond>
                <i-button @click="showModalCond(instruction)" style="width: 150px;">
                  Show conditions
                </i-button>
                <div v-if="showAllTabs" style="margin-top:7px;text-align:center">
                  {{ categoriesNames[instruction.category_id] }}
                </div>
              </div>
            </td>
            <td am-img-block>
              <div
                class="_position:relative _margin-bottom:1/2"
                am-img
                v-for="(url, el) in instruction.image_urls"
                :key="url"
              >
                <img
                  class="_width:100%"
                  :src="url"
                />
                <p class="_margin:1/4">{{ instruction.images_names[el] }}</p>
                <div am-hover @click="showModal({ url: url })">
                  <svg>
                    <use xlink:href="@/assets/icons.svg#open-modal" />
                  </svg>
                </div>
              </div>
            </td>
            <td class="_position:relative _width:50%" v-if="instruction.content">
              <contentView :content="instruction.content.replaceAll('\n', '<br>')" />
              <div am-gradient="bottom"></div>
            </td>
            <td>
              <IToggle @update:modelValue="updateStatus(instruction.id, $event)" :modelValue="setIsActive(instruction.status)" />
            </td>
            <td am-actions>
              <i-button
                color="primary"
                @click="$router.push({
                  name: 'InstructionForm',
                  params: {
                    id: instruction.id
                  },
                  query: {
                    ...$route.params,
                    ...$route.query
                  }
                })"
                style="width: 100px;"
                class="_margin-bottom:1/2"
              >
                Edit
              </i-button>
              <i-button
                color="info"
                @click="$router.push({
                  name: 'InstructionForm',
                  params: {
                    id: 'copy_' + instruction.id
                  },
                  query: {
                    ...$route.params,
                    ...$route.query
                  }
                })"
                style="width: 100px;"
                class="_margin-bottom:1/2"
              >
                Copy
              </i-button>
              <i-button @click="remove(instruction.id)" style="width: 100px;">
                Delete
              </i-button>
            </td>
          </tr>
        </tbody>
      </i-table>
      <image-modal  v-if="instructions.modal.isShow" />
      <cond-modal v-if="instructions.modalCond.isShow" />
      <i-card v-if="isNeedPagination">
        <i-pagination
          v-model="page"
          :items-total="instructions.instructionsData[$route.params.subtable].totalCount"
          :items-per-page="instructions.itemsPerPage" />
      </i-card>
      <i-modal v-model="confirmDelete">
        <template #header>
          Delete this Step?
        </template>
        <div am-deleted-buttons>
          <i-button @click="notRemoved">
            No
          </i-button>
          <i-button @click="removed">
            Yes
          </i-button>
        </div>
      </i-modal>
    </div>
    <div
      v-else
      class="_align-self:stretch _display:flex _justify-content:center _align-items:center _height:100%"
    >
      <i-loader color="primary" />
    </div>
  </i-container>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import imageModal from '../components/instructions/imageModal.vue'
import condModal from '../components/instructions/condModal.vue'
import filterItem from '../components/instructions/filterItem.vue'
import contentView from '../components/instructions/contentView.vue'

export default {
  inject: ['inkline'],
  data: () => ({
    searchValue: '',
    page: 1,
    timer: null,
    confirmDelete: false,
    isDeleteId: null,
    isOpenFilter: false,
    showAllTabs: false,
    categoriesNames: {}
  }),
  components: {
    imageModal,
    filterItem,
    contentView,
    condModal
  },
  computed: {
    ...mapState([
      'partCategories',
      'instructions'
    ]),
    ...mapGetters('partCategories', ['subCategories']),
    isNeedPagination () {
      if ((this.instructions.instructionsData[this.$route.params.subtable].totalCount / this.instructions.itemsPerPage) > 1) {
        return true
      } else return false
    }
  },
  watch: {
    page (val) {
      this.$router.push({
        query: {
          page: val,
          search: this.$route.query.search,
          filter: this.$route.query.filter,
          attrs: this.$route.query.attrs
        }
      })
    },
    searchValue (val) {
      clearTimeout(this.timer)
      this.timer = window.setTimeout(() => {
        if (val) {
          this.$router.push({
            query: {
              page: this.page,
              search: val,
              filter: this.$route.query.filter,
              attrs: this.$route.query.attrs
            }
          })
        } else {
          this.$router.push({
            query: {
              page: this.page,
              filter: this.$route.query.filter,
              attrs: this.$route.query.attrs
            }
          })
        }
      }, 500)
    }
  },
  methods: {
    ...mapActions('instructions', ['getInstructions', 'deleteInstruction', 'updateInstruction']),
    ...mapActions('partCategories', ['getPartCategories', 'setCategories', 'getIdByCode']),
    ...mapMutations('partCategories', ['setSubSubCategory']),
    ...mapMutations('instructions', ['showModal']),
    ...mapMutations('instructions', ['showModalCond']),
    updateStatus (id, event) {
      this.updateInstruction({
        value: {
          status: event ? 'ACTIVE' : 'INACTIVE'
        },
        id: id
      })
    },
    setIsActive (val) {
      if (val === 'INACTIVE') return false
      if (val === 'ACTIVE') return true
    },
    async changeActiveTab (tab) {
      this.setSubSubCategory({ code: tab.id + '-' + tab.code })
      const maincatId = await this.getIdByCode({ code: this.$route.params.db })
      const subcatId = await this.getIdByCode({ code: this.$route.params.table, level: 1 })
      this.$router.push({
        name: 'InstructionsView',
        params: { subtable: tab.id + '-' + tab.code + '-' + subcatId + '-' + maincatId }
      })
    },
    remove (id) {
      this.confirmDelete = true
      this.isDeleteId = id
    },
    notRemoved () {
      this.confirmDelete = false
      this.isDeleteId = null
    },
    async removed () {
      this.confirmDelete = false
      const isDelete = await this.deleteInstruction(this.isDeleteId)
      if (isDelete) {
        if (this.page !== 1) this.page = 1
        else this.getInstructions({ routeParams: this.$route.params, page: this.page })
      }
    },
    updateFilter (event) {
      const query = {
        page: 1,
        search: this.$route.query.search
      }
      if (event.filter.length) {
        query.filter = JSON.stringify(event.filter)
        query.attrs = JSON.stringify(event.attrs)
      }
      this.$router.push({
        query: { ...query }
      })
    },
    setShowAllTabs (event) {
      this.showAllTabs = event
      window.localStorage.setItem('showAllTabs', this.showAllTabs)
    }
  },
  async beforeMount () {
    if (this.partCategories.data.length === 0) await this.getPartCategories()
    this.setCategories(this.$route.params)
    this.$watch(
      () => this.$route.params,
      () => {
        if (!this.$route.params.subtable) return
        if (this.$route.query.page) {
          this.page = Number(this.$route.query.page)
        } else this.page = 1
        if (this.$route.query.search) {
          this.searchValue = this.$route.query.search
        } else this.searchValue = ''
        this.getInstructions({
          routeParams: this.$route.params,
          page: this.page,
          searchValue: this.searchValue,
          filter: this.$route.query.filter
        })
        this.setCategories(this.$route.params)
      },
      { immediate: true }
    )
    this.$watch(
      () => this.showAllTabs,
      () => {
        this.getInstructions({
          routeParams: this.$route.params,
          page: this.page,
          searchValue: this.searchValue,
          filter: this.$route.query.filter
        })
      },
      { immediate: true }
    )
    if (window.localStorage.getItem('showAllTabs')) {
      this.showAllTabs = JSON.parse(window.localStorage.getItem('showAllTabs'))
    }
    this.partCategories.rawData.forEach(item => {
      this.categoriesNames[item.id] = item.name
    })
  }
}
</script>

<style lang="scss">
[am-instruction-table] {
  overflow: auto;
  [am-deleted-buttons] {
    display: flex;
    justify-content: space-between;
    button {
      width: calc(50% - 5px);
    }
  }
  [am-index] {
    width: 40px;
  }
  [am-id] {
    width: 55px;
  }
  [am-name] {
    max-width: 13rem;
    min-width: 5rem;
  }
  [am-actions] {
    width: 100px;
  }
  [am-img-block] {
    width: 15rem;
    max-height: 30rem;
    min-width: 10rem;
    [am-img] {
      [am-hover] {
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.6);
        svg {
          margin: 10px;
        }
      }
      &:hover [am-hover] {
        display: block;
        cursor: pointer;
      }
    }
  }
  .toggle .toggle-label::before {
    border-color: var(--color--dark-45);
  }
  [am-gradient] {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 10px;
  }
}
</style>
